import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { tokenStorage } from '../lib/tokenStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * GoogleCallback
 * Lands here after our own backend completes the Google OAuth code exchange and
 * redirects with the app JWT in the URL hash (#access_token=...). We store it,
 * load the user via /auth/me, and enter the app. No third-party auth involved.
 */
const GoogleCallback = () => {
  const navigate = useNavigate();
  const { setUserFromOAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return; // guard against StrictMode double-run
    done.current = true;

    const run = async () => {
      const match = window.location.hash.match(/access_token=([^&]+)/);
      if (!match) {
        navigate('/login?error=google_failed', { replace: true });
        return;
      }
      const token = decodeURIComponent(match[1]);
      try {
        tokenStorage.setToken(token);
        const res = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserFromOAuth(token, res.data);
        navigate('/', { replace: true });
      } catch (e) {
        tokenStorage.removeToken();
        navigate('/login?error=google_failed', { replace: true });
      }
    };
    run();
  }, [navigate, setUserFromOAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4" />
        <p className="text-gray-600">Signing you in with Google…</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
